import { render, staticRenderFns } from "./PropertyList.vue?vue&type=template&id=fce1c2ca&scoped=true"
import script from "./PropertyList.vue?vue&type=script&lang=js"
export * from "./PropertyList.vue?vue&type=script&lang=js"
import style0 from "./PropertyList.vue?vue&type=style&index=0&id=fce1c2ca&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce1c2ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fce1c2ca')) {
      api.createRecord('fce1c2ca', component.options)
    } else {
      api.reload('fce1c2ca', component.options)
    }
    module.hot.accept("./PropertyList.vue?vue&type=template&id=fce1c2ca&scoped=true", function () {
      api.rerender('fce1c2ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/entrytypes/PropertyList.vue"
export default component.exports